/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AggregationResultDto } from '../models/aggregation-result-dto';
import { dashboardClientsGet } from '../fn/dashboard/dashboard-clients-get';
import { DashboardClientsGet$Params } from '../fn/dashboard/dashboard-clients-get';
import { dashboardClientsGet$Plain } from '../fn/dashboard/dashboard-clients-get-plain';
import { DashboardClientsGet$Plain$Params } from '../fn/dashboard/dashboard-clients-get-plain';
import { dashboardFlowsGet } from '../fn/dashboard/dashboard-flows-get';
import { DashboardFlowsGet$Params } from '../fn/dashboard/dashboard-flows-get';
import { dashboardFlowsGet$Plain } from '../fn/dashboard/dashboard-flows-get-plain';
import { DashboardFlowsGet$Plain$Params } from '../fn/dashboard/dashboard-flows-get-plain';
import { dashboardGet } from '../fn/dashboard/dashboard-get';
import { DashboardGet$Params } from '../fn/dashboard/dashboard-get';
import { dashboardGetByClientPocGet } from '../fn/dashboard/dashboard-get-by-client-poc-get';
import { DashboardGetByClientPocGet$Params } from '../fn/dashboard/dashboard-get-by-client-poc-get';
import { dashboardGetSubmissionSummariesPost } from '../fn/dashboard/dashboard-get-submission-summaries-post';
import { DashboardGetSubmissionSummariesPost$Params } from '../fn/dashboard/dashboard-get-submission-summaries-post';
import { dashboardGetSubmissionSummariesPost$Plain } from '../fn/dashboard/dashboard-get-submission-summaries-post-plain';
import { DashboardGetSubmissionSummariesPost$Plain$Params } from '../fn/dashboard/dashboard-get-submission-summaries-post-plain';
import { dashboardHistoricalTrainingStatisticsGet } from '../fn/dashboard/dashboard-historical-training-statistics-get';
import { DashboardHistoricalTrainingStatisticsGet$Params } from '../fn/dashboard/dashboard-historical-training-statistics-get';
import { dashboardHistoricalTrainingStatisticsGet$Plain } from '../fn/dashboard/dashboard-historical-training-statistics-get-plain';
import { DashboardHistoricalTrainingStatisticsGet$Plain$Params } from '../fn/dashboard/dashboard-historical-training-statistics-get-plain';
import { dashboardLayoutsGet } from '../fn/dashboard/dashboard-layouts-get';
import { DashboardLayoutsGet$Params } from '../fn/dashboard/dashboard-layouts-get';
import { dashboardLayoutsGet$Plain } from '../fn/dashboard/dashboard-layouts-get-plain';
import { DashboardLayoutsGet$Plain$Params } from '../fn/dashboard/dashboard-layouts-get-plain';
import { dashboardMachineClassificationsByDayGet } from '../fn/dashboard/dashboard-machine-classifications-by-day-get';
import { DashboardMachineClassificationsByDayGet$Params } from '../fn/dashboard/dashboard-machine-classifications-by-day-get';
import { dashboardMachineClassificationsByDayGet$Plain } from '../fn/dashboard/dashboard-machine-classifications-by-day-get-plain';
import { DashboardMachineClassificationsByDayGet$Plain$Params } from '../fn/dashboard/dashboard-machine-classifications-by-day-get-plain';
import { dashboardMachineClassificationsByMonthGet } from '../fn/dashboard/dashboard-machine-classifications-by-month-get';
import { DashboardMachineClassificationsByMonthGet$Params } from '../fn/dashboard/dashboard-machine-classifications-by-month-get';
import { dashboardMachineClassificationsByMonthGet$Plain } from '../fn/dashboard/dashboard-machine-classifications-by-month-get-plain';
import { DashboardMachineClassificationsByMonthGet$Plain$Params } from '../fn/dashboard/dashboard-machine-classifications-by-month-get-plain';
import { dashboardPagesProcessedPerDayGet } from '../fn/dashboard/dashboard-pages-processed-per-day-get';
import { DashboardPagesProcessedPerDayGet$Params } from '../fn/dashboard/dashboard-pages-processed-per-day-get';
import { dashboardPagesProcessedPerDayGet$Plain } from '../fn/dashboard/dashboard-pages-processed-per-day-get-plain';
import { DashboardPagesProcessedPerDayGet$Plain$Params } from '../fn/dashboard/dashboard-pages-processed-per-day-get-plain';
import { dashboardSubmissionsPerClientGet } from '../fn/dashboard/dashboard-submissions-per-client-get';
import { DashboardSubmissionsPerClientGet$Params } from '../fn/dashboard/dashboard-submissions-per-client-get';
import { dashboardSubmissionsPerClientGet$Plain } from '../fn/dashboard/dashboard-submissions-per-client-get-plain';
import { DashboardSubmissionsPerClientGet$Plain$Params } from '../fn/dashboard/dashboard-submissions-per-client-get-plain';
import { dashboardSubmissionsPerDateGet } from '../fn/dashboard/dashboard-submissions-per-date-get';
import { DashboardSubmissionsPerDateGet$Params } from '../fn/dashboard/dashboard-submissions-per-date-get';
import { dashboardSubmissionsPerDateGet$Plain } from '../fn/dashboard/dashboard-submissions-per-date-get-plain';
import { DashboardSubmissionsPerDateGet$Plain$Params } from '../fn/dashboard/dashboard-submissions-per-date-get-plain';
import { dashboardSubmissionsPerDayGet } from '../fn/dashboard/dashboard-submissions-per-day-get';
import { DashboardSubmissionsPerDayGet$Params } from '../fn/dashboard/dashboard-submissions-per-day-get';
import { dashboardSubmissionsPerDayGet$Plain } from '../fn/dashboard/dashboard-submissions-per-day-get-plain';
import { DashboardSubmissionsPerDayGet$Plain$Params } from '../fn/dashboard/dashboard-submissions-per-day-get-plain';
import { dashboardSubmissionsPerDocumentTypeGet } from '../fn/dashboard/dashboard-submissions-per-document-type-get';
import { DashboardSubmissionsPerDocumentTypeGet$Params } from '../fn/dashboard/dashboard-submissions-per-document-type-get';
import { dashboardSubmissionsPerDocumentTypeGet$Plain } from '../fn/dashboard/dashboard-submissions-per-document-type-get-plain';
import { DashboardSubmissionsPerDocumentTypeGet$Plain$Params } from '../fn/dashboard/dashboard-submissions-per-document-type-get-plain';
import { dashboardSyncDataWithElasticGet } from '../fn/dashboard/dashboard-sync-data-with-elastic-get';
import { DashboardSyncDataWithElasticGet$Params } from '../fn/dashboard/dashboard-sync-data-with-elastic-get';
import { dashboardSyncDataWithElasticGet$Plain } from '../fn/dashboard/dashboard-sync-data-with-elastic-get-plain';
import { DashboardSyncDataWithElasticGet$Plain$Params } from '../fn/dashboard/dashboard-sync-data-with-elastic-get-plain';
import { HistoricalTrainingStatisticsResult } from '../models/historical-training-statistics-result';
import { PagesProcessedPerDayDto } from '../models/pages-processed-per-day-dto';
import { SubmissionsPerClientDto } from '../models/submissions-per-client-dto';
import { SubmissionsPerDateDto } from '../models/submissions-per-date-dto';
import { SubmissionsPerDayDto } from '../models/submissions-per-day-dto';
import { SubmissionsPerDocumentTypeDto } from '../models/submissions-per-document-type-dto';
import { SubmissionSummaryResult } from '../models/submission-summary-result';

@Injectable({ providedIn: 'root' })
export class DashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dashboardGetByClientPocGet()` */
  static readonly DashboardGetByClientPocGetPath = '/Dashboard/GetByClientPoc';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardGetByClientPocGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardGetByClientPocGet$Response(params?: DashboardGetByClientPocGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return dashboardGetByClientPocGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardGetByClientPocGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardGetByClientPocGet(params?: DashboardGetByClientPocGet$Params, context?: HttpContext): Observable<void> {
    return this.dashboardGetByClientPocGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `dashboardGet()` */
  static readonly DashboardGetPath = '/Dashboard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardGet$Response(params?: DashboardGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return dashboardGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardGet(params?: DashboardGet$Params, context?: HttpContext): Observable<void> {
    return this.dashboardGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `dashboardGetSubmissionSummariesPost()` */
  static readonly DashboardGetSubmissionSummariesPostPath = '/Dashboard/GetSubmissionSummaries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardGetSubmissionSummariesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardGetSubmissionSummariesPost$Plain$Response(params?: DashboardGetSubmissionSummariesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionSummaryResult>> {
    return dashboardGetSubmissionSummariesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardGetSubmissionSummariesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardGetSubmissionSummariesPost$Plain(params?: DashboardGetSubmissionSummariesPost$Plain$Params, context?: HttpContext): Observable<SubmissionSummaryResult> {
    return this.dashboardGetSubmissionSummariesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionSummaryResult>): SubmissionSummaryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardGetSubmissionSummariesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardGetSubmissionSummariesPost$Response(params?: DashboardGetSubmissionSummariesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionSummaryResult>> {
    return dashboardGetSubmissionSummariesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardGetSubmissionSummariesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardGetSubmissionSummariesPost(params?: DashboardGetSubmissionSummariesPost$Params, context?: HttpContext): Observable<SubmissionSummaryResult> {
    return this.dashboardGetSubmissionSummariesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionSummaryResult>): SubmissionSummaryResult => r.body)
    );
  }

  /** Path part for operation `dashboardClientsGet()` */
  static readonly DashboardClientsGetPath = '/Dashboard/clients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardClientsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardClientsGet$Plain$Response(params?: DashboardClientsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return dashboardClientsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardClientsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardClientsGet$Plain(params?: DashboardClientsGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.dashboardClientsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardClientsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardClientsGet$Response(params?: DashboardClientsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return dashboardClientsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardClientsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardClientsGet(params?: DashboardClientsGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.dashboardClientsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `dashboardFlowsGet()` */
  static readonly DashboardFlowsGetPath = '/Dashboard/flows';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardFlowsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFlowsGet$Plain$Response(params?: DashboardFlowsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return dashboardFlowsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardFlowsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFlowsGet$Plain(params?: DashboardFlowsGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.dashboardFlowsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardFlowsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFlowsGet$Response(params?: DashboardFlowsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return dashboardFlowsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardFlowsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFlowsGet(params?: DashboardFlowsGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.dashboardFlowsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `dashboardLayoutsGet()` */
  static readonly DashboardLayoutsGetPath = '/Dashboard/layouts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardLayoutsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardLayoutsGet$Plain$Response(params?: DashboardLayoutsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return dashboardLayoutsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardLayoutsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardLayoutsGet$Plain(params?: DashboardLayoutsGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.dashboardLayoutsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardLayoutsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardLayoutsGet$Response(params?: DashboardLayoutsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return dashboardLayoutsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardLayoutsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardLayoutsGet(params?: DashboardLayoutsGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.dashboardLayoutsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `dashboardHistoricalTrainingStatisticsGet()` */
  static readonly DashboardHistoricalTrainingStatisticsGetPath = '/Dashboard/historical-training-statistics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardHistoricalTrainingStatisticsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardHistoricalTrainingStatisticsGet$Plain$Response(params?: DashboardHistoricalTrainingStatisticsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HistoricalTrainingStatisticsResult>>> {
    return dashboardHistoricalTrainingStatisticsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardHistoricalTrainingStatisticsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardHistoricalTrainingStatisticsGet$Plain(params?: DashboardHistoricalTrainingStatisticsGet$Plain$Params, context?: HttpContext): Observable<Array<HistoricalTrainingStatisticsResult>> {
    return this.dashboardHistoricalTrainingStatisticsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HistoricalTrainingStatisticsResult>>): Array<HistoricalTrainingStatisticsResult> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardHistoricalTrainingStatisticsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardHistoricalTrainingStatisticsGet$Response(params?: DashboardHistoricalTrainingStatisticsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HistoricalTrainingStatisticsResult>>> {
    return dashboardHistoricalTrainingStatisticsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardHistoricalTrainingStatisticsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardHistoricalTrainingStatisticsGet(params?: DashboardHistoricalTrainingStatisticsGet$Params, context?: HttpContext): Observable<Array<HistoricalTrainingStatisticsResult>> {
    return this.dashboardHistoricalTrainingStatisticsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HistoricalTrainingStatisticsResult>>): Array<HistoricalTrainingStatisticsResult> => r.body)
    );
  }

  /** Path part for operation `dashboardSyncDataWithElasticGet()` */
  static readonly DashboardSyncDataWithElasticGetPath = '/Dashboard/sync-data-with-elastic';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSyncDataWithElasticGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSyncDataWithElasticGet$Plain$Response(params?: DashboardSyncDataWithElasticGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return dashboardSyncDataWithElasticGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSyncDataWithElasticGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSyncDataWithElasticGet$Plain(params?: DashboardSyncDataWithElasticGet$Plain$Params, context?: HttpContext): Observable<string> {
    return this.dashboardSyncDataWithElasticGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSyncDataWithElasticGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSyncDataWithElasticGet$Response(params?: DashboardSyncDataWithElasticGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return dashboardSyncDataWithElasticGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSyncDataWithElasticGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSyncDataWithElasticGet(params?: DashboardSyncDataWithElasticGet$Params, context?: HttpContext): Observable<string> {
    return this.dashboardSyncDataWithElasticGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `dashboardSubmissionsPerClientGet()` */
  static readonly DashboardSubmissionsPerClientGetPath = '/Dashboard/submissions-per-client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSubmissionsPerClientGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerClientGet$Plain$Response(params?: DashboardSubmissionsPerClientGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerClientDto>>> {
    return dashboardSubmissionsPerClientGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSubmissionsPerClientGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerClientGet$Plain(params?: DashboardSubmissionsPerClientGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsPerClientDto>> {
    return this.dashboardSubmissionsPerClientGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsPerClientDto>>): Array<SubmissionsPerClientDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSubmissionsPerClientGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerClientGet$Response(params?: DashboardSubmissionsPerClientGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerClientDto>>> {
    return dashboardSubmissionsPerClientGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSubmissionsPerClientGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerClientGet(params?: DashboardSubmissionsPerClientGet$Params, context?: HttpContext): Observable<Array<SubmissionsPerClientDto>> {
    return this.dashboardSubmissionsPerClientGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsPerClientDto>>): Array<SubmissionsPerClientDto> => r.body)
    );
  }

  /** Path part for operation `dashboardSubmissionsPerDateGet()` */
  static readonly DashboardSubmissionsPerDateGetPath = '/Dashboard/submissions-per-date';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSubmissionsPerDateGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDateGet$Plain$Response(params?: DashboardSubmissionsPerDateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDateDto>>> {
    return dashboardSubmissionsPerDateGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSubmissionsPerDateGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDateGet$Plain(params?: DashboardSubmissionsPerDateGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsPerDateDto>> {
    return this.dashboardSubmissionsPerDateGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsPerDateDto>>): Array<SubmissionsPerDateDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSubmissionsPerDateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDateGet$Response(params?: DashboardSubmissionsPerDateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDateDto>>> {
    return dashboardSubmissionsPerDateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSubmissionsPerDateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDateGet(params?: DashboardSubmissionsPerDateGet$Params, context?: HttpContext): Observable<Array<SubmissionsPerDateDto>> {
    return this.dashboardSubmissionsPerDateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsPerDateDto>>): Array<SubmissionsPerDateDto> => r.body)
    );
  }

  /** Path part for operation `dashboardSubmissionsPerDocumentTypeGet()` */
  static readonly DashboardSubmissionsPerDocumentTypeGetPath = '/Dashboard/submissions-per-document-type';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSubmissionsPerDocumentTypeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDocumentTypeGet$Plain$Response(params?: DashboardSubmissionsPerDocumentTypeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDocumentTypeDto>>> {
    return dashboardSubmissionsPerDocumentTypeGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSubmissionsPerDocumentTypeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDocumentTypeGet$Plain(params?: DashboardSubmissionsPerDocumentTypeGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsPerDocumentTypeDto>> {
    return this.dashboardSubmissionsPerDocumentTypeGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsPerDocumentTypeDto>>): Array<SubmissionsPerDocumentTypeDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSubmissionsPerDocumentTypeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDocumentTypeGet$Response(params?: DashboardSubmissionsPerDocumentTypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDocumentTypeDto>>> {
    return dashboardSubmissionsPerDocumentTypeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSubmissionsPerDocumentTypeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDocumentTypeGet(params?: DashboardSubmissionsPerDocumentTypeGet$Params, context?: HttpContext): Observable<Array<SubmissionsPerDocumentTypeDto>> {
    return this.dashboardSubmissionsPerDocumentTypeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsPerDocumentTypeDto>>): Array<SubmissionsPerDocumentTypeDto> => r.body)
    );
  }

  /** Path part for operation `dashboardPagesProcessedPerDayGet()` */
  static readonly DashboardPagesProcessedPerDayGetPath = '/Dashboard/pages-processed-per-day';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardPagesProcessedPerDayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardPagesProcessedPerDayGet$Plain$Response(params?: DashboardPagesProcessedPerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PagesProcessedPerDayDto>>> {
    return dashboardPagesProcessedPerDayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardPagesProcessedPerDayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardPagesProcessedPerDayGet$Plain(params?: DashboardPagesProcessedPerDayGet$Plain$Params, context?: HttpContext): Observable<Array<PagesProcessedPerDayDto>> {
    return this.dashboardPagesProcessedPerDayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PagesProcessedPerDayDto>>): Array<PagesProcessedPerDayDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardPagesProcessedPerDayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardPagesProcessedPerDayGet$Response(params?: DashboardPagesProcessedPerDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PagesProcessedPerDayDto>>> {
    return dashboardPagesProcessedPerDayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardPagesProcessedPerDayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardPagesProcessedPerDayGet(params?: DashboardPagesProcessedPerDayGet$Params, context?: HttpContext): Observable<Array<PagesProcessedPerDayDto>> {
    return this.dashboardPagesProcessedPerDayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PagesProcessedPerDayDto>>): Array<PagesProcessedPerDayDto> => r.body)
    );
  }

  /** Path part for operation `dashboardMachineClassificationsByDayGet()` */
  static readonly DashboardMachineClassificationsByDayGetPath = '/Dashboard/machine-classifications-by-day';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardMachineClassificationsByDayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardMachineClassificationsByDayGet$Plain$Response(params?: DashboardMachineClassificationsByDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregationResultDto>>> {
    return dashboardMachineClassificationsByDayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardMachineClassificationsByDayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardMachineClassificationsByDayGet$Plain(params?: DashboardMachineClassificationsByDayGet$Plain$Params, context?: HttpContext): Observable<Array<AggregationResultDto>> {
    return this.dashboardMachineClassificationsByDayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AggregationResultDto>>): Array<AggregationResultDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardMachineClassificationsByDayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardMachineClassificationsByDayGet$Response(params?: DashboardMachineClassificationsByDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregationResultDto>>> {
    return dashboardMachineClassificationsByDayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardMachineClassificationsByDayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardMachineClassificationsByDayGet(params?: DashboardMachineClassificationsByDayGet$Params, context?: HttpContext): Observable<Array<AggregationResultDto>> {
    return this.dashboardMachineClassificationsByDayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AggregationResultDto>>): Array<AggregationResultDto> => r.body)
    );
  }

  /** Path part for operation `dashboardMachineClassificationsByMonthGet()` */
  static readonly DashboardMachineClassificationsByMonthGetPath = '/Dashboard/machine-classifications-by-month';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardMachineClassificationsByMonthGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardMachineClassificationsByMonthGet$Plain$Response(params?: DashboardMachineClassificationsByMonthGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregationResultDto>>> {
    return dashboardMachineClassificationsByMonthGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardMachineClassificationsByMonthGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardMachineClassificationsByMonthGet$Plain(params?: DashboardMachineClassificationsByMonthGet$Plain$Params, context?: HttpContext): Observable<Array<AggregationResultDto>> {
    return this.dashboardMachineClassificationsByMonthGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AggregationResultDto>>): Array<AggregationResultDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardMachineClassificationsByMonthGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardMachineClassificationsByMonthGet$Response(params?: DashboardMachineClassificationsByMonthGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregationResultDto>>> {
    return dashboardMachineClassificationsByMonthGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardMachineClassificationsByMonthGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardMachineClassificationsByMonthGet(params?: DashboardMachineClassificationsByMonthGet$Params, context?: HttpContext): Observable<Array<AggregationResultDto>> {
    return this.dashboardMachineClassificationsByMonthGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AggregationResultDto>>): Array<AggregationResultDto> => r.body)
    );
  }

  /** Path part for operation `dashboardSubmissionsPerDayGet()` */
  static readonly DashboardSubmissionsPerDayGetPath = '/Dashboard/submissions-per-day';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSubmissionsPerDayGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDayGet$Plain$Response(params?: DashboardSubmissionsPerDayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDayDto>>> {
    return dashboardSubmissionsPerDayGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSubmissionsPerDayGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDayGet$Plain(params?: DashboardSubmissionsPerDayGet$Plain$Params, context?: HttpContext): Observable<Array<SubmissionsPerDayDto>> {
    return this.dashboardSubmissionsPerDayGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsPerDayDto>>): Array<SubmissionsPerDayDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardSubmissionsPerDayGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDayGet$Response(params?: DashboardSubmissionsPerDayGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDayDto>>> {
    return dashboardSubmissionsPerDayGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardSubmissionsPerDayGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardSubmissionsPerDayGet(params?: DashboardSubmissionsPerDayGet$Params, context?: HttpContext): Observable<Array<SubmissionsPerDayDto>> {
    return this.dashboardSubmissionsPerDayGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubmissionsPerDayDto>>): Array<SubmissionsPerDayDto> => r.body)
    );
  }

}
